export enum FileSizeEnum {
    MB_50 = 50_000_001,
}
